export default __webpack_public_path__ + "static/media/icon_loading.96f66c73.gif";